import { render } from "./Flag.vue?vue&type=template&id=50880304"
import script from "./Flag.vue?vue&type=script&lang=ts"
export * from "./Flag.vue?vue&type=script&lang=ts"
script.render = render

export default script